import React, { useState } from "react";
import { Button, Card, Dropdown, Tooltip, Image } from "antd";
import {
  DownloadOutlined,
  EditOutlined,
  ShareAltOutlined,
  DeleteOutlined,
  EllipsisOutlined,
  TeamOutlined
} from "@ant-design/icons";
import FileIcon from "./FileIcon";
import moment from "moment";
import { isAuthenticated } from "../Auth/auth";

import { useTranslation } from "react-i18next";
const { Meta } = Card;

const DocumentCard = ({ document, onDownload, onEdit, onShare, onDelete }) => {
  const { t } = useTranslation("dashboard");
  const [imageError, setImageError] = useState(false);

  const isImage =
    document?.fileExtension &&
    ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"].includes(
      document?.fileExtension.toLowerCase()
    );

  const formatFileSize = bytes => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const getPreviewUrl = () => {
    let url = process.env.REACT_APP_BACKEND_URL;
    let backendUrl = url.split("/api")[0];
    let previewUrl = `${backendUrl}/${document?.filePath}`;

    return previewUrl;
  };

  const menuItems = [
    {
      key: "download",
      label: t("Download"),
      icon: <DownloadOutlined />,
      onClick: onDownload
    },
    {
      key: "edit",
      label: t("Edit"),
      disabled: (document?.owner || document?.owner?._id) !== isAuthenticated()?.serviceProviderId,
      icon: <EditOutlined />,
      onClick: onEdit
    },
    {
      key: "share",
      label: t("Share"),
      icon: <ShareAltOutlined />,
      disabled: (document?.owner || document?.owner?._id) !== isAuthenticated()?.serviceProviderId,
      onClick: onShare
    },
    {
      key: "delete",
      label: t("Delete"),
      disabled: (document?.owner || document?.owner?._id) !== isAuthenticated()?.serviceProviderId,
      icon: <DeleteOutlined />,
      danger: true,
      onClick: onDelete
    }
  ];

  const renderCover = () => {
    if (isImage && !imageError) {
      return (
        <div className="file-preview-container">
          <Image
            src={getPreviewUrl()}
            fallback={
              "https://img.freepik.com/free-photo/parrot_649448-132.jpg?semt=ais_items_boosted&w=740"
            }
            preview={{
              mask: <div>{t("Preview")}</div>
            }}
            width="100%"
            height="100%"
            style={{ objectFit: "cover" }}
            onError={() => setImageError(true)}
          />
        </div>
      );
    }

    return (
      <div className="file-icon">
        <FileIcon extension={document?.fileExtension} size={48} />
      </div>
    );
  };

  return (
    <Card
      hoverable
      className="file-card document-card"
      cover={renderCover()}
      actions={[
        <Dropdown
          menu={{ items: menuItems }}
          placement="bottomRight"
          trigger={["click"]}
          key="actions"
        >
          <Button
            type="text"
            block
            icon={<EllipsisOutlined />}
            aria-label={t("More actions")}
            className="file-card__more"
          />
        </Dropdown>
      ]}
    >
      <Meta
        title={
          <Tooltip title={document?.name}>
            <div className="file-title">
              {document?.sharedWith?.length > 0 && (
                <TeamOutlined className="file-shared-icon" aria-label={t("Share")} />
              )}
              <span className="file-title__text">{document?.name}</span>
            </div>
          </Tooltip>
        }
        description={
          <div>
            <div className="file-size">{formatFileSize(document?.fileSize)}</div>
            <div className="file-date">
              {t("Uploaded At")}: {moment(document?.createdAt).format("DD/MM/YYYY")}
            </div>
          </div>
        }
      />
    </Card>
  );
};

export default DocumentCard;
